export default {
  path: 'clients',
  name: 'Clients',
};
